import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { DetectedDefinition } from '../schemas/DetectedDefinition';
import { CS_BASE_URL } from '../utils/ProjectUrls';

const DEFINITIONS_PATH = '/definitions';

// 使用createApi创建一个新的API slice
// Use createApi to create a new API slice
export const definitionSlice = createApi({
    // 定义这个slice的reducer路径
    // Define the reducer path for this slice
    // 命名空間：reducerPath 作為這個 slice 的命名空間，確保這個 API slice 管理的狀態不會與 Redux store 中的其他 slice 發生衝突。這有助於保持清晰的結構，避免潛在的命名衝突。
    // 狀態樹結構：reducerPath 的值決定了這個 slice 的 reducer 會掛載在 Redux 狀態樹的哪個位置。例如，如果 reducerPath 設置為 "definition"，這個 slice 的狀態就會存儲在 state.definition 下。
    // Namespace: reducerPath acts as the namespace for this slice, ensuring that the state managed by this API slice doesn't clash with other slices in the Redux store. This helps in maintaining a clear structure and avoiding potential naming conflicts.
    // State Tree Structure: The value of reducerPath determines where the reducer for this slice will be mounted in the Redux state tree. For example, if reducerPath is set to "definition", the state for this slice will be stored under state.definition.
    reducerPath: 'definition',
    // 设置API请求的基本URL
    // Set the base URL for API requests
    baseQuery: fetchBaseQuery({ baseUrl: CS_BASE_URL }),
    // 定义API endpoints
    // Define the API endpoints
    endpoints: (builder) => ({
        // 定义一个用于获取定义数据的query endpoint
        // Define a query endpoint for fetching definition data
        getDefinitions: builder.query<DetectedDefinition[], void>({
            // 指定请求的具体路径
            // Specify the specific path for the request
            query: () => DEFINITIONS_PATH,

            // 我把/definitions的keepUnusedDataFor設置成 Number.MAX_SAFE_INTEGER
            // I set the keepUnusedDataFor for /definitions to Number.MAX_SAFE_INTEGER
            // 這樣就不用一直發送相同的api
            // This way, the same API call won't be repeatedly sent.
            keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
        }),
        getDefinitionsById: builder.query<DetectedDefinition, number>({
            // 指定请求的具体路径
            // Specify the specific path for the request
            query: (definitonId) => `${DEFINITIONS_PATH}/${definitonId}`,
        }),
        getAncestors: builder.query<DetectedDefinition[], number>({
            // 指定请求的具体路径
            // Specify the specific path for the request
            query: (definitonId) => `${DEFINITIONS_PATH}/${definitonId}/ancestors`,
        }),
        // 可以继续添加更多endpoints
        // More endpoints can be added here
    }),
});

// 从definitionSlice中导出自动生成的hook
// Export the auto-generated hook from the definitionSlice
export const {
    useGetDefinitionsQuery,
    useLazyGetAncestorsQuery,
    useLazyGetDefinitionsByIdQuery,
    useLazyGetDefinitionsQuery,
} = definitionSlice;
